import { ReactNode } from "react";
import { MDSIconFunction, MDSIconKind } from "@/mds/components/icon";
import { MDSTooltipConfig } from "@/mds/components/tooltip";

export interface MDSMenuItemProps {
  id: string;
  label: string;
  variant?: MDSMenuItemVariant;
  icon?: MDSIconKind | MDSIconFunction;
  iconVariant?: MDSMenuItemIconVariant;
  subtitle?: string | ReactNode;
  extraText?: string;
  isShared?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  selectionVariant?: MDSMenuItemSelectionVariant;
  textValue?: string;
  rightAddon?: () => ReactNode;
  onClick?: () => void;
  onHover?: () => void;
  tooltipConfig?: MDSTooltipConfig;
}

export enum MDSMenuItemVariant {
  OneLine = "OneLine",
  TwoLine = "TwoLine",
}

export enum MDSMenuItemSelectionVariant {
  Checkmark = "Checkmark",
  RadioButton = "RadioButton",
  Hover = "Hover",
}

export enum MDSMenuItemIconVariant {
  Icon = "Icon",
  Avatar = "Avatar",
}
